import { useState, useEffect } from "react";
import { Download, Share } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

export default function PWAInstall() {
  const [deferred, setDeferred] = useState(null);
  const [showHelp, setShowHelp] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const isStandalone =
    window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
  if (isStandalone) return null;

  const onClick = async () => {
    if (deferred) {
      deferred.prompt();
      await deferred.userChoice;
      setDeferred(null);
    } else {
      setShowHelp(true);
    }
  };

  return (
    <>
      <Button
        data-testid="pwa-install-button"
        onClick={onClick}
        size="sm"
        variant="outline"
        className="border-white/15 bg-white/5 text-white hover:bg-white/10 hidden sm:inline-flex"
      >
        <Download className="h-4 w-4 sm:mr-1.5" />
        <span className="hidden lg:inline">Install app</span>
      </Button>

      <Dialog open={showHelp} onOpenChange={setShowHelp}>
        <DialogContent className="bg-[#0C1017] border-white/10 text-white">
          <DialogHeader>
            <DialogTitle className="font-heading">Add to Home Screen</DialogTitle>
            <DialogDescription className="text-slate-400">
              Install XtreamFlix to launch it full-screen like an app.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 text-sm text-slate-300">
            <div>
              <p className="font-semibold text-white flex items-center gap-1.5">
                <Share className="h-4 w-4" /> On iPhone / iPad (Safari)
              </p>
              <p className="text-slate-400 mt-1">
                Tap the Share button, then choose <b>Add to Home Screen</b>.
              </p>
            </div>
            <div>
              <p className="font-semibold text-white">On Android / Desktop (Chrome)</p>
              <p className="text-slate-400 mt-1">
                Open the browser menu (⋮) and choose <b>Install app</b> / <b>Add to Home screen</b>.
              </p>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
